import * as React from "react";

function SvgClose(props) {
  return <svg width={13} height={13} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.5.5l12 12m-12 0l12-12" stroke="#000" /></svg>;
}

export default SvgClose;